import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useBarometerAgentSet() {
  const { startListen } = useWebSocketStore()
  const { updateBarometerCarData } = useUpdateCar()
  const { sessionData } = useAutobidAuth()

  const agentSet = () => {
    startListen({
      eventName: 'premium.AGENT_SET',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, auctionId, price, userId } = event.context

        if (userId !== sessionData.value?.user?.id)
          return

        updateBarometerCarData(auctionId, carId, (data) => {
          return {
            ...data,
            ownBidAgentAmount: price,
          }
        })
      },
    })
  }

  return { agentSet }
}
